var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center"}},[_c('v-divider'),_c('div',{staticClass:"text-on-divider"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }